export default function Question() {
    return (
        <svg className="default" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                className="circle"
                d="M9 16.25C12.7279 16.25 15.75 13.2279 15.75 9.5C15.75 5.77208 12.7279 2.75 9 2.75C5.27208 2.75 2.25 5.77208 2.25 9.5C2.25 13.2279 5.27208 16.25 9 16.25Z"
                stroke="#949494"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.81641 7.25006C6.99273 6.74881 7.34077 6.32614 7.79887 6.05691C8.25697 5.78768 8.79558 5.68926 9.31929 5.77909C9.843 5.86893 10.318 6.1412 10.6602 6.54771C11.0024 6.95421 11.1897 7.4687 11.1889 8.00006C11.1889 9.50006 8.93891 10.2501 8.93891 10.2501V11.3751"
                stroke="#949494"
                strokeWidth="1.125"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 13.25H9.0075" stroke="#949494" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
